import { distinctString, fixedEncodeURIComponent } from '@studio/utils/utils';
export const FONT_SERVICE_TEXT_PARAMETER = '&t=';
export const getFontServiceParamsFromString = (text) => {
    const distinctText = distinctString(text);
    return {
        textParams: FONT_SERVICE_TEXT_PARAMETER + fixedEncodeURIComponent(distinctText),
        distinctText
    };
};
